"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Safety() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const microItems = ["Dermatologist tested", "Travel-friendly", "Family-safe"];
  return <section data-section-id="16276" id="childcare-school-safety" className="relative overflow-hidden bg-background text-foreground">
      <div className="relative mx-auto max-w-4xl px-6 py-24 md:px-10 md:py-32">
        {}
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <svg className="h-[640px] w-[640px] max-w-none animate-[drift_24s_ease-in-out_infinite] opacity-[0.08] motion-reduce:animate-none" viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <radialGradient id="fireflyDrift" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="hsl(174 42% 45%)" stopOpacity="1" />
                <stop offset="100%" stopColor="hsl(174 42% 45%)" stopOpacity="0" />
              </radialGradient>
            </defs>
            <path d="M300 60c80 0 140 40 180 100s50 130 30 200-80 130-160 160-170 20-230-30-90-130-80-210 50-150 120-190S260 60 300 60z" fill="url(#fireflyDrift)" />
          </svg>
        </div>

        <style>{`
          @keyframes drift {
            0%, 100% { transform: translate(0px, 0px); }
            25% { transform: translate(12px, -12px); }
            50% { transform: translate(-12px, 12px); }
            75% { transform: translate(12px, 12px); }
          }
        `}</style>

        <div ref={ref} className={`relative text-center transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          <h2 className="font-default font-medium tracking-tight text-foreground" style={{
          fontSize: "clamp(2.25rem, 5vw, 4rem)",
          lineHeight: 1.05,
          letterSpacing: "-0.015em"
        }}>
            {"Prepared for "}
            <em className="font-default not-italic text-primary" style={{
            fontStyle: "italic"
          }}>
              peace
            </em>
            {" of mind."}
          </h2>

          <p className="mx-auto mt-6 max-w-2xl font-default text-lg leading-relaxed md:text-xl text-foreground/70">
            B.Y.E. Hygiene Mist™ provides a simple, portable way to maintain cleanliness in schools and childcare centers. Keep your environment protected, one gentle mist at a time.
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-5 sm:flex-row sm:gap-8">
            <Button asChild className="rounded-lg px-7 py-6 text-base font-semibold tracking-tight transition-transform duration-300 hover:scale-[1.04] bg-primary text-white shadow-md">
              <Link to="/Shop">Shop the collection</Link>
            </Button>

            <Link to="/PreparednessHubPage" className="group inline-flex items-center font-default text-base font-medium transition-colors duration-200 text-foreground">
              <span className="border-b border-transparent pb-0.5 transition-colors duration-200 group-hover:border-primary" style={{
              textUnderlineOffset: "4px"
            }}>
                Learn about our mission
              </span>
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 font-default text-sm font-medium text-foreground/60" style={{
          letterSpacing: "0.01em"
        }}>
            {microItems.map((item, i) => <div data-index={i} key={item} className="flex items-center gap-4">
                {i > 0 && <span aria-hidden="true" className="inline-block h-1 w-1 rounded-lg bg-foreground/30" />}
                <span>{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}